import { Artifact } from "../services/artifacts";
import { WorkbookExtractionRuleSet } from "../services/worksheetExtraction";

export const workbookExtractionRules: Record<string, WorkbookExtractionRuleSet> = {
    "ReviewToolingTest": {
        workbookCode: "ReviewToolingTest",
        worksheets: {
            "M25_RENTAL_PROPERTY": [
                {
                    id: "extract-m25-root",
                    name: "Extract M25 Structure",
                    targetSchemaId: "schema.workpaper.m25",
                    ranges: {
                        "Client Name": "B2",
                        "Property Address": "B3"
                    },
                    extract: async ({ worksheetNamedRanges, workbookId, worksheetId }) => {
                        // Example extraction logic
                        // Assuming B2 is Client Name and B3 is Property Address
                        const clientNameRange = worksheetNamedRanges["Client Name"];
                        const propertyAddressRange = worksheetNamedRanges["Property Address"];
                        const clientArtifact: Artifact = {
                            id: `${workbookId}-${worksheetId}-client`,
                            type: "schema.entity.client",
                            correlationIDs: [],
                            properties: {
                                name: clientNameRange
                            },
                            artifacts: [],
                            dependencies: [{
                                artifactId: `m25-${workbookId}-${worksheetId}`,
                                type: 'parent',
                                properties: {
                                    range: "B2"
                                }
                            }]
                        };

                        const propertyArtifact: Artifact = {
                            id: `${workbookId}-${worksheetId}-property`,
                            type: "schema.asset.property",
                            correlationIDs: [],
                            properties: {
                                address: propertyAddressRange
                            },
                            artifacts: [],
                            dependencies: [{
                                artifactId: `m25-${workbookId}-${worksheetId}`,
                                type: 'parent',
                                properties: {
                                    range: "B3"
                                }
                            }]
                        };

                        // Return the Root Artifact containing the leaves
                        return [{
                            id: `m25-${workbookId}-${worksheetId}`,
                            type: 'schema.workpaper.m25',
                            correlationIDs: [],
                            properties: {
                                workpaperId: "M25-AUTO-GEN"
                            },
                            artifacts: [clientArtifact, propertyArtifact],
                            dependencies: [{
                                artifactId: `worksheet-${worksheetId}`,
                                type: 'source',
                                properties: {}
                            }]
                        }];
                    }
                }
            ]
        }
    }
};
